import api from '@api/endpoints';
import { BBPS_CONSTANTS as types } from '@store/constants';
import { setAlert } from '@store/actions/alertActions';
import { getErrorMessage } from '@utils';
import { ALERT_STATUS_TYPE } from '@constants';
import { ORDERS } from '@store/constants';

export const getBBPSCategories = ({ onSuccess, onComplete, onError } = {}) => async (dispatch) => {
    try {
        dispatch({
            type: types.GETTING_BBPS_CATEGORIES,
        });
        
        const { data } = await api.bbps.getBBPSCategories();

        dispatch({
            type: types.GET_BBPS_CATEGORIES_SUCCESS,
            payload: data
        });

        onSuccess && onSuccess(data);
    } catch (error) {
        dispatch(
            setAlert({
                title: getErrorMessage({
                    error,
                    genericMessage: 'Failed to get BBPS categories!'
                }),
                status: ALERT_STATUS_TYPE.ERROR
            })
        );
        dispatch({
            type: types.GET_BBPS_CATEGORIES_FAILURE,
            payload: error
        });
        onError && onError(error);
    } finally {
        onComplete && onComplete();
    }
};


export const updateBBPSCategory = ({ updateData, onSuccess, onComplete, onError }) => async (dispatch) => {
    try {
        dispatch({
            type: types.UPDATING_BBPS_CATEGORY,
        });

        const { data } = await api.bbps.updateBBPSCategory({
            payload: updateData,
        });

        dispatch({
            type: types.UPDATE_BBPS_CATEGORY_SUCCESS,
            payload: data,
        });

        // Refresh the categories list after update
        dispatch(getBBPSCategories());

        onSuccess && onSuccess(data);

    } catch (error) {
        dispatch(
            setAlert({
                title: getErrorMessage({
                    error,
                    genericMessage: 'Failed to update BBPS category!'
                }),
                status: ALERT_STATUS_TYPE.ERROR
            })
        );
        dispatch({
            type: types.UPDATE_BBPS_CATEGORY_FAILURE,
            payload: error
        });
        onError && onError(error);
    } finally {
        onComplete && onComplete();
    }
};


export const deleteBBPSCategory = ({ categoryId, onSuccess, onComplete, onError }) => async (dispatch) => {
            try {
                dispatch({
                    type: types.DELETING_BBPS_CATEGORY,
                });

                const { data } = await api.bbps.deleteBBPSCategory({
                    categoryId,
                });

                dispatch({
                    type: types.DELETE_BBPS_CATEGORY_SUCCESS,
                    payload: data,
                });

                // Refresh the categories list after delete
                dispatch(getBBPSCategories());

                onSuccess && onSuccess(data);
            } catch (error) {
                dispatch(
                    setAlert({
                        title: getErrorMessage({
                            error,
                            genericMessage: 'Failed to delete BBPS category!'
                        }),
                        status: ALERT_STATUS_TYPE.ERROR
                    })
                );
                dispatch({
                    type: types.DELETE_BBPS_CATEGORY_FAILURE,
                    payload: error
                });
                onError && onError(error);
            } finally {
                onComplete && onComplete();
            }
        };

export const clearBBPSCategories = () => (dispatch) => {
    dispatch({
        type: types.CLEAR_BBPS_CATEGORIES,
    });
};


export const getBBPSComplaints =
  ({ orderId, onSuccess, onComplete, onError }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ORDERS.GETTING_BBPS_COMPLAINTS
      });

      const { data } = await api.bbps.getBBPSComplaints({ orderId });
      
      dispatch({
        type: ORDERS.GET_BBPS_COMPLAINTS_SUCCESS,
        payload: data
      });

      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch({
        type: ORDERS.GET_BBPS_COMPLAINTS_FAILURE,
        payload: error
      });
      
      dispatch(
        setAlert({
          title: error?.message || 'Failed to fetch BBPS complaints',
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      onError && onError(error);
    } finally {
      onComplete && onComplete();
    }
  };

export const createBBPSComplaint =
  ({ payload, onSuccess, onComplete, onError }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ORDERS.CREATING_BBPS_COMPLAINT
      });

      const { data } = await api.bbps.createBBPSComplaint({ payload });
      
      dispatch({
        type: ORDERS.CREATE_BBPS_COMPLAINT_SUCCESS,
        payload: data
      });

      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch({
        type: ORDERS.CREATE_BBPS_COMPLAINT_FAILURE,
        payload: error
      });
      
      dispatch(
        setAlert({
          title: error?.message || 'Failed to create BBPS complaint',
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      onError && onError(error);
    } finally {
      onComplete && onComplete();
    }
  };

export const updateBBPSComplaint =
  ({ complaintId, payload, onSuccess, onComplete, onError }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ORDERS.UPDATING_BBPS_COMPLAINT
      });

      const { data } = await api.bbps.updateBBPSComplaint({ complaintId, payload });
      
      dispatch({
        type: ORDERS.UPDATE_BBPS_COMPLAINT_SUCCESS,
        payload: data
      });

      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch({
        type: ORDERS.UPDATE_BBPS_COMPLAINT_FAILURE,
        payload: error
      });
      
      dispatch(
        setAlert({
          title: error?.message || 'Failed to update BBPS complaint',
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      onError && onError(error);
    } finally {
      onComplete && onComplete();
    }
  };

export const setBBPSSearchOrderId = (searchOrderId) => ({
  type: ORDERS.SET_BBPS_SEARCH_ORDER_ID,
  payload: searchOrderId
});

export const setBBPSCurrentOrderId = (currentOrderId) => ({
  type: ORDERS.SET_BBPS_CURRENT_ORDER_ID,
  payload: currentOrderId
});

export const clearBBPSComplaints = () => ({
  type: ORDERS.CLEAR_BBPS_COMPLAINTS
});

